import BaseAPI from "./BaseAPI";
import SimCardAlert from "../models/SimCardAlert";
import isString from "lodash/isString";


export default class SimAPI extends BaseAPI {
    
    async deactivateSimCard(iccid, date) {
        return await this.request(`/-/sim/${iccid}/deactivate`, 'PUT', { date });
    }
    async activateSimCard(iccid, date) {
        return await this.request(`/-/sim/${iccid}/activate`, 'PUT', { date });
    }
    async retireSimCard(iccid, date) {
        return await this.request(`/-/sim/${iccid}/retire`, 'PUT', { date });
    }
    async cancelSimCardSchedule(iccid) {
        return await this.request(`/-/sim/${iccid}/cancelSchedule`, 'PUT');
    }
    async saveSimCard(simCard) {
        return await this.request( '/-/sim', 'PUT', simCard.toJS());
    }
    
    async getSimCardInfo(iccid) {
        return await this.request(`/-/sim/${iccid}`, 'GET');
    }
    
    async getSimCards() {
        return await this.request(`/-/sim`, 'GET');
    }
    
    async getAlerts() {
        return await this.request(`/-/sim/alert`, 'GET');
    }
    
    async saveAlert(alert: SimCardAlert) {
        if(!isString(alert.triggerThreshold)) alert = alert.set('triggerThreshold', JSON.stringify(alert.triggerThreshold));
        return await this.request(`/-/sim/alert`, alert.id ? 'PUT': 'POST', { alert });
    }
    async deleteAlert(alert: SimCardAlert) {
        return await this.request(`/-/sim/alert`, 'DELETE', { alertId: alert.id });
    }
    
}